(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    const option = event.target.closest(
      'variant-picker input[data-variant-id]'
    );

    if (!option) return;

    const productComponent = option.closest('product-component');

    if (!productComponent) return;

    const bisButton = productComponent.querySelector(
      '.BIS_trigger.bis-4b12-trigger'
    );

    if (!bisButton) return;

    bisButton.setAttribute(
      'data-variant-id',
      option.dataset.variantId
    );
  });
  } catch(e) { console.error(e); }
})();

})();
